import { interpolateStringWithData, pluralize } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { PublisherInfo } from '../PublisherInfo';
import { UserReviewInfoProps } from './UserReviewInfo.types';

export const UserReviewInfo = ({
  avatarUrl,
  microcopy,
  username = '',
  memberSince,
  reviewCount,
  link = '',
  helpfulVoteCount,
  className,
}: UserReviewInfoProps) => {
  return (
    <div className={c('mt-4', className)}>
      <PublisherInfo
        publisherName={username}
        publisherLink={link}
        showAvatar={true}
        isCertified={false}
        microcopy={{
          certifiedPublisher: microcopy.certifiedPublisher,
          verifiedOrganization: microcopy.verifiedOrganization,
          verifiedIndividual: microcopy.verifiedIndividual,
        }}
        publisherAvatarUrl={avatarUrl}
        className="mb-2 w-48"
      />
      <ul className="text-sm text-grey-600 [&_li]:mb-1.5">
        {memberSince && (
          <li>
            {interpolateStringWithData(microcopy.memberSince, {
              date: memberSince,
            })}
          </li>
        )}

        {reviewCount && (
          <li>{pluralize('reviewCount', microcopy, parseInt(reviewCount))}</li>
        )}

        {helpfulVoteCount && (
          <li>
            {pluralize(
              'helpfulVoteCount',
              microcopy,
              parseInt(helpfulVoteCount)
            )}
          </li>
        )}
      </ul>
    </div>
  );
};
